import React, { useState, useEffect } from 'react';
import { Form, Select, Input, Button, DatePicker, InputNumber, Card, Alert, Divider, Typography, Space, Row, Col, Layout, Modal } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import './LeerkrachtScreen.css';
import AxiosCaller from '../../../authenticatie/AxiosCaller';
import dayjs from 'dayjs';
import { openNotificationSuccess, openNotificationError } from '../../../Components/Notification/Notification';
import { Role } from '../../../Services/auth.service';
import GetUserInfo from "../../authenticatie/GetUserInfo";
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { Content } = Layout;
const currentUser = GetUserInfo();
// Main component
function LeerkrachtScreen() {
    return (
        <Layout className='Screen-container'>
            
                <h1 className='title'>Menu plannen</h1>
                <Inputs />

        </Layout>
    );
}

const Inputs = () => {
    const { get } = AxiosCaller();
    const location = useLocation();
    const voorstel = location.state;
    const navigate = useNavigate();
    const [form] = Form.useForm();

    // States for the screen
    const [voorgerechten, setVoorgerechten] = useState([]);
    const [hoofdgerechten, setHoofdgerechten] = useState([]);
    const [nagerechten, setNagerechten] = useState([]);
    const [klassen, setKlassen] = useState([]);
    const [selectedKlas, setSelectedKlas] = useState(null);
    const [selectedKlasType, setSelectedKlasType] = useState('');
    const [aantalStudenten, setAantalStudenten] = useState('');
    const [selectedVoorgerecht, setSelectedVoorgerecht] = useState(null);
    const [selectedHoofdgerecht, setSelectedHoofdgerecht] = useState(null);
    const [selectedNagerecht, setSelectedNagerecht] = useState(null);
    const [datum1, setDatum1] = useState(null);
    const [datum2, setDatum2] = useState(null);
    const [datum3, setDatum3] = useState(null);
    const [opmerking, setOpmerking] = useState('');
    const [allergenen, setAllergenen] = useState([]);
    const [allergenenVoorgerecht, setAllergenenVoorgerecht] = useState([]);
    const [allergenenHoofdgerecht, setAllergenenHoofdgerecht] = useState([]);
    const [allergenenNagerecht, setAllergenenNagerecht] = useState([]);
    const [aantalVoorgerecht, setAantalVoorgerecht] = useState('');
    const [aantalHoofdgerecht, setAantalHoofdgerecht] = useState('');
    const [aantalNagerecht, setAantalNagerecht] = useState('');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [maxHeight, setMaxHeight] = useState(0);
    const [isEdit, setIsEdit]= useState(false)
      
          useEffect(() => {
              const updateHeight = () => {
                  setMaxHeight(0.7 * document.documentElement.clientHeight);
              };
      
              updateHeight(); // Initialiseren bij eerste render
              window.addEventListener("resize", updateHeight); // Updaten bij schermresizing
      
              return () => window.removeEventListener("resize", updateHeight); // Cleanup
          }, []);

    // Fetch classes from the database
    const fetchKlassen = async () => {
        try {
            const response = await get('/klas');
            setKlassen(response.data);
            return response.data;
        } catch (error) {
            console.error("error fetching klassen"+ error)
            openNotificationError("Fout bij ophalen van klassen", error)
            return [];
        }
    };

    const fetchVoorgerechten = async (klasType) => {
        try {
            const id = klasType?._id;
            const url = id 
                ? `/recept/voorgerechten/${id}` 
                : `/recept/voorgerechten`;

            const response = await get(url);
            setVoorgerechten(response.data);
            return response.data;
        } catch (error) {
            console.error("error fetch voorgerechten"+error);
            openNotificationError("Fout bij ophalen van voorgerechten", error)
            return [];
        }
    }; 

    const fetchHoofdgerechten = async (klasType) => {
        try {
            const id = klasType?._id;
            const url = id 
                ? `/Recept/hoofdgerechten/${id}` 
                : `/Recept/hoofdgerechten`;
        
            const response = await get(url);
            setHoofdgerechten(response.data);
            return response.data;
        } catch (error) {
            console.error("error fetch hoofdgerechten"+error);
            openNotificationError("Fout bij ophalen van hoofdgerechten", error)
            return [];
        }
    };
     
    const fetchDesserts = async (klasType) => {
        try {
            const id = klasType?._id;
            const url = id 
                ? `/Recept/nagerechten/${id}` 
                : `/Recept/nagerechten`;
        
            const response = await get(url);
            setNagerechten(response.data);
            return response.data;
        } catch (error) {

            console.error("error fetch nagerecht"+error);
            openNotificationError("Fout bij ophalen van nagerechten", error)
            return [];
        }
    };

   
    useEffect(() => {   
        const fetchData = async () => {
            try {
                await Promise.all([
                    fetchVoorgerechten(),
                    fetchHoofdgerechten(),
                    fetchDesserts(),
                    fetchKlassen()
                ]);
                setDataLoaded(true);
            } catch (error) {
                console.error("Error fetching data:", error);
                openNotificationError("Fout bij ophalen vna data", error)
            }
        };
    
        fetchData();
    }, []);

    // Effect to handle loading data when returning with a proposal
    useEffect(() => {
        if (dataLoaded && voorstel) {
            loadVoorstelData();
        }
    }, [dataLoaded]);

    useEffect(() => {
        if (selectedVoorgerecht || selectedHoofdgerecht || selectedNagerecht) {
            checkAllergenenKlas(selectedKlas);
        }
    }, [selectedVoorgerecht, selectedHoofdgerecht, selectedNagerecht]);
    
    useEffect(() => {
        const loadKlasTypeData = async () => {
            if (selectedKlasType) {
                await Promise.all([
                    fetchVoorgerechten(selectedKlasType),
                    fetchHoofdgerechten(selectedKlasType),
                    fetchDesserts(selectedKlasType)
                ]);
            }
        };
        
        loadKlasTypeData();
    }, [selectedKlasType]);
     
   
    const loadVoorstelData = async () => {
        if (!voorstel) return;
    
      
    
        const isEdit = voorstel?.isEdit;

        setIsEdit(voorstel?._id)
        
        // Extract values
        const { 
            voorgerecht, hoofdgerecht, nagerecht, 
            aantalStudenten, aantalHoofdgerecht, aantalVoorgerecht, aantalNagerecht,
            datum1, datum2, datum3, kookDatum, 
            opmerking, klas, allergenen,
            allergenenVoorgerecht, allergenenHoofdgerecht, allergenenNagerecht 
        } = voorstel;
    
        // Set class and student count
        setSelectedKlas(klas || null);
        setSelectedKlasType(klas?.klasType || null);
        setAantalStudenten(aantalStudenten || 0);
    
        // Parse date with enhanced error handling
        const parseDate = (date) => {
            if (!date) return null;
            
            try {
                // If it's already a dayjs object
                if (date && date.$isDayjsObject) {
                    return dayjs(date.$d).utc();
                }
                
                // Otherwise try to parse it as a date string
                return dayjs(date).utc();
            } catch (error) {
                console.error("Error parsing date:", error);
                return null;
            }
        };
    
        // Set dates - handle both edit mode and back mode
        setDatum1(parseDate(isEdit ? kookDatum : datum1));
        setDatum2(parseDate(datum2));
        setDatum3(parseDate(datum3));
        
        // Helper function to check if dish has name (valid dish)
        const hasName = (dish) => dish && dish.naam;
        
        // Helper function to determine if we should use a dish's quantity
        const shouldUseQuantity = (dish, specificQuantity) => {
            // Use specific quantity if available (like aantalVoorgerecht)
            if (specificQuantity !== undefined && specificQuantity !== null) {
                return specificQuantity;
            }
            // Otherwise use dish's quantity if available
            else if (dish && dish.aantal) {
                return dish.aantal;
            }
            // Fall back to student count
            return aantalStudenten;
        };
        
        // Set quantities
        setAantalVoorgerecht(shouldUseQuantity(voorgerecht, aantalVoorgerecht));
        setAantalHoofdgerecht(shouldUseQuantity(hoofdgerecht, aantalHoofdgerecht));
        setAantalNagerecht(shouldUseQuantity(nagerecht, aantalNagerecht));
        
        // Set additional form data
        setOpmerking(opmerking || '');
        
        // Set allergens
        setAllergenen(allergenen || []);
        setAllergenenVoorgerecht(allergenenVoorgerecht || []);
        setAllergenenHoofdgerecht(allergenenHoofdgerecht || []);
        setAllergenenNagerecht(allergenenNagerecht || []);
    
        // Fetch dishes if class type is available
        if (klas?.klasType) {
           
            try {
                // Fetch dishes
                const [voorgerechtenData, hoofdgerechtenData, nagerechtData] = await Promise.all([
                    fetchVoorgerechten(klas.klasType),
                    fetchHoofdgerechten(klas.klasType),
                    fetchDesserts(klas.klasType)
                ]);
                
                // Set selected dishes - only if they have a name
                if (hasName(voorgerecht)) {
                    const found = voorgerechtenData.find(v => 
                        v._id === voorgerecht._id || 
                        v.naam === voorgerecht.naam
                    );
                 
                    setSelectedVoorgerecht(found || voorgerecht);
                } else {
                    setSelectedVoorgerecht(null);
                }
                
                if (hasName(hoofdgerecht)) {
                    const found = hoofdgerechtenData.find(h => 
                        h._id === hoofdgerecht._id || 
                        h.naam === hoofdgerecht.naam
                    );
                    
                    setSelectedHoofdgerecht(found || hoofdgerecht);
                } else {
                    setSelectedHoofdgerecht(null);
                }
                
                if (hasName(nagerecht)) {
                    const found = nagerechtData.find(n => 
                        n._id === nagerecht._id || 
                        n.naam === nagerecht.naam
                    );
                 
                    setSelectedNagerecht(found || nagerecht);
                } else {
                    setSelectedNagerecht(null);
                }
    
                // Update form values
                setTimeout(() => {
                    try {
                        // Create fresh dayjs objects for form
                        const formDatum1 = parseDate(isEdit ? kookDatum : datum1);
                        const formDatum2 = parseDate(datum2);
                        const formDatum3 = parseDate(datum3);
                        
                        // Determine selected dish IDs
                        const voorId = hasName(voorgerecht) ? 
                            (voorgerecht._id || voorgerechtenData.find(v => v.naam === voorgerecht.naam)?._id) : null;
                        
                        const hoofdId = hasName(hoofdgerecht) ? 
                            (hoofdgerecht._id || hoofdgerechtenData.find(h => h.naam === hoofdgerecht.naam)?._id) : null;
                        
                        const nageId = hasName(nagerecht) ? 
                            (nagerecht._id || nagerechtData.find(n => n.naam === nagerecht.naam)?._id) : null;
                        
                        // Set form values
                        form.setFieldsValue({
                            klas: klas?._id || null,
                            aantal: aantalStudenten,
                            
                            datum1: formDatum1,
                            datum2: formDatum2,
                            datum3: formDatum3,
                            
                            voorgerecht: voorId,
                            hoofdgerecht: hoofdId, 
                            nagerecht: nageId,
                            
                            aantalVoorgerecht: shouldUseQuantity(voorgerecht, aantalVoorgerecht),
                            aantalHoofdgerecht: shouldUseQuantity(hoofdgerecht, aantalHoofdgerecht),
                            aantalNagerecht: shouldUseQuantity(nagerecht, aantalNagerecht),
                            
                            opmerking: opmerking || ''
                        });
                        
                      
                    } catch (error) {
                        console.error("Error setting form values:", error);
                    }
                }, 100);
                
            } catch (error) {
                console.error("Error fetching dishes:", error);
            }
        }
    };

    const handleKlasChange = (value) => {
        const selectedKlas = klassen.find(k => k._id === value);
        
        if (selectedKlas?.klasType?.naam !== selectedKlasType?.naam) {
            setSelectedVoorgerecht(null);
            setSelectedHoofdgerecht(null);
            setSelectedNagerecht(null);
            setAllergenenNagerecht([]);
            setAllergenenVoorgerecht([]);
            setAllergenenHoofdgerecht([]);
            form.setFieldsValue({
                voorgerecht: null,
                hoofdgerecht: null,
                nagerecht: null
            });
        }
    
        setSelectedKlas(selectedKlas);
        setAantalStudenten(selectedKlas?.aantal || ""); 
        setAantalVoorgerecht(selectedKlas?.aantal);
        setAantalHoofdgerecht(selectedKlas?.aantal);
        setAantalNagerecht(selectedKlas?.aantal);
        setSelectedKlasType(selectedKlas?.klasType || ""); 

        form.setFieldsValue({
            aantal: selectedKlas?.aantal || "",
            aantalVoorgerecht: selectedKlas?.aantal || "",
            aantalHoofdgerecht: selectedKlas?.aantal || "",
            aantalNagerecht: selectedKlas?.aantal || ""
        });
    };
            
    const checkAllergenenKlas = (klas) => {
        setAllergenenNagerecht([]);
        setAllergenenVoorgerecht([]);
        setAllergenenHoofdgerecht([]);
        let globalAllergenenSet = new Set(allergenen); 
    
        if (selectedVoorgerecht) {
            const array = allergenenCheck(klas, selectedVoorgerecht);
            if (array.length > 0) {
                setAllergenenVoorgerecht(array);
                array.forEach((allergen) => globalAllergenenSet.add(allergen));
            }
        }

        if (selectedHoofdgerecht) {
            const array = allergenenCheck(klas, selectedHoofdgerecht);
            if (array.length > 0) {
                setAllergenenHoofdgerecht(array);
                array.forEach((allergen) => globalAllergenenSet.add(allergen));
            }
        }
    
        if (selectedNagerecht) {
            const array = allergenenCheck(klas, selectedNagerecht);
            if (array.length > 0) {
                setAllergenenNagerecht(array);
                array.forEach((allergen) => globalAllergenenSet.add(allergen));
            }
        }
    
        setAllergenen([...globalAllergenenSet]);
    };
    
    const handleAantalChange = (value) => {
        setAantalStudenten(value);
        setAantalVoorgerecht(value);
        setAantalHoofdgerecht(value);
        setAantalNagerecht(value);

        form.setFieldsValue({
            aantalVoorgerecht: value,
            aantalHoofdgerecht: value,
            aantalNagerecht: value
        });
    };

    const handleDatumChange = (index, date) => {
     
        const today = dayjs().startOf('day').utc();
        
        if (date && dayjs(date).utc() < today) {
            // Clear the date in state
            if (index === 1) {
                setDatum1(null);
                form.setFieldsValue({ datum1: null });
            }
            if (index === 2) {
                setDatum2(null);
                form.setFieldsValue({ datum2: null });
            }
            if (index === 3) {
                setDatum3(null);
                form.setFieldsValue({ datum3: null });
            }
            openNotificationError("Datum mag niet in het verleden liggen!");
        } else {
            // Store as UTC but preserve the local time values
            const preservedLocalTime = date ? dayjs(date).utc(true) : null;
           

            if (index === 1) {
                setDatum1(preservedLocalTime);
                form.setFieldsValue({ datum1: preservedLocalTime });
            }
            if (index === 2) {
                setDatum2(preservedLocalTime);
                form.setFieldsValue({ datum2: preservedLocalTime });
            }
            if (index === 3) {
                setDatum3(preservedLocalTime);
                form.setFieldsValue({ datum3: preservedLocalTime });
            }
        }
    }
    
    const handleVoorgerechtChange = (value) => {
        var selectedRecept = value
        if(value != undefined){
            selectedRecept = voorgerechten.find(v => v._id === value);
            checkAllergenen(selectedRecept);
        }
        setSelectedVoorgerecht(selectedRecept);
        
    };

    const handleHoofdgerechtChange = (value) => {
        var selectedRecept = value
        if(value != undefined){
             selectedRecept = hoofdgerechten.find(h => h._id === value);
             setSelectedHoofdgerecht(selectedRecept);
        }
        
        checkAllergenen(selectedRecept);
    };

    const handleNagerechtChange = (value) => {
        var selectedRecept = value 
        if (value != undefined){
            selectedRecept = nagerechten.find(d => d._id === value);
        setSelectedNagerecht(selectedRecept);
        }
         
        checkAllergenen(selectedRecept);
    };

    const handleOpmerkingChange = (e) => setOpmerking(e.target.value);
    const handleAantalVoorgerechtChange = (value) => setAantalVoorgerecht(value);
    const handleAantalHoofdgerechtChange = (value) => setAantalHoofdgerecht(value);
    const handleAantalNagerechtChange = (value) => setAantalNagerecht(value);
    
    const checkAllergenen = (recept) => {
        if (!selectedKlas || !selectedKlas.allergenen) {
            return;
        }
    
        const allergenenArray = allergenenCheck(selectedKlas, recept);
        let globalAllergenenSet = new Set(allergenen);
    
        if (allergenenArray.length > 0) {
            if (recept.type === "voorgerecht") {
                setAllergenenVoorgerecht(allergenenArray);
            } else if (recept.type === "hoofdgerecht") {
                setAllergenenHoofdgerecht(allergenenArray);
            } else {
                setAllergenenNagerecht(allergenenArray);
            }
            allergenenArray.forEach((allergen) => globalAllergenenSet.add(allergen));
        } else {
            if (recept.type === "voorgerecht") {
                setAllergenenVoorgerecht([]);
            } else if (recept.type === "hoofdgerecht") {
                setAllergenenHoofdgerecht([]);
            } else {
                setAllergenenNagerecht([]);
            }
        }
    
        setAllergenen([...globalAllergenenSet]);
    };
    
    const allergenenCheck = (selectedKlas, recept) => {
        if (!selectedKlas || !recept) return [];

        const klasAllergenenNamen = selectedKlas.allergenen.map(a => a.allergeen.naam);
        const allergenenSet = new Set();
    
        recept.producten.forEach(product => {
            if (!product.product || !product.product.allergenen) {
                return;
            }
    
            product.product.allergenen.forEach(allergeen => {
                if (klasAllergenenNamen.includes(allergeen.naam)) {
                    allergenenSet.add(allergeen.naam);
                }
            });
        });
    
        return Array.from(allergenenSet);
    };
    
    const validateFormEnNavigeer = () => {
        // Reset previous form validation errors
        form.validateFields()
            .then(values => {
                // Create a list of validation errors
                const errors = [];
                
                // Check if at least one dish is selected
                if (!selectedVoorgerecht && !selectedHoofdgerecht && !selectedNagerecht) {
                    errors.push("Selecteer minstens 1 gerecht!");
                }
                
                // Check dish-quantity pairs
                if (selectedVoorgerecht && (!aantalVoorgerecht || aantalVoorgerecht <= 0)) {
                    errors.push("Vul een geldig aantal in voor het voorgerecht");
                    form.setFields([{ name: 'aantalVoorgerecht', errors: ['Vul een geldig aantal in'] }]);
                }
                
                if (selectedHoofdgerecht && (!aantalHoofdgerecht || aantalHoofdgerecht <= 0)) {
                    errors.push("Vul een geldig aantal in voor het hoofdgerecht");
                    form.setFields([{ name: 'aantalHoofdgerecht', errors: ['Vul een geldig aantal in'] }]);
                }
                
                if (selectedNagerecht && (!aantalNagerecht || aantalNagerecht <= 0)) {
                    errors.push("Vul een geldig aantal in voor het nagerecht");
                    form.setFields([{ name: 'aantalNagerecht', errors: ['Vul een geldig aantal in'] }]);
                }
                
                // Check if klas is selected
                if (!selectedKlas) {
                    errors.push("Selecteer een klas");
                    form.setFields([{ name: 'klas', errors: ['Selecteer een klas'] }]);
                }
                
                // Check if at least one date is selected
                if (!datum1) {
                    errors.push("Selecteer tenminste datum 1");
                    form.setFields([{ name: 'datum1', errors: ['Selecteer een datum'] }]);
                }
                
                // If there are errors, show them and stop
                if (errors.length > 0) {
                    openNotificationError(errors[0]);
                    return;
                }
                
                // If all validations pass, prepare data and navigate
                const formdata = {
                    klas: selectedKlas,
                    aantalStudenten: aantalStudenten,
                    datum1: datum1,
                    datum2: datum2,
                    datum3: datum3,
                    voorgerecht: selectedVoorgerecht,
                    hoofdgerecht: selectedHoofdgerecht,
                    nagerecht: selectedNagerecht,
                    opmerking: opmerking,
                    allergenen: allergenen,
                    allergenenVoorgerecht: allergenenVoorgerecht,
                    allergenenHoofdgerecht: allergenenHoofdgerecht,
                    allergenenNagerecht: allergenenNagerecht,
                    aantalVoorgerecht: aantalVoorgerecht,
                    aantalHoofdgerecht: aantalHoofdgerecht,
                    aantalNagerecht: aantalNagerecht,
                    _id: voorstel?._id
                };
    
          
                
                // Get current user with better logging
                const userInfo = GetUserInfo();
             
                
                // Ensure navigate function is properly defined and working
                try {
                    // Get user role with fallback
                    const userRole = userInfo?.rol || (currentUser ? currentUser.rol : null);
                    
                    
                    // Default path for navigation
                    let navigatePath = '/voorstel';
                    
                    // Adjust path based on role if available
                    if (userRole === Role.Besteller || userRole === Role.Gebruikersbeheerder) {
                        navigatePath = '/admin/bestelling/voorstel';
                    }
                    
               
                    navigate(navigatePath, { state: formdata });
                } catch (error) {
                    console.error("Navigation error:", error);
                    openNotificationError("Er is een fout opgetreden bij het navigeren naar het overzicht");
                    
                    // Fallback navigation - try direct navigation to default path
                    try {
                        
                        navigate('/voorstel', { state: formdata });
                    } catch (fallbackError) {
                        console.error("Fallback navigation also failed:", fallbackError);
                        openNotificationError("Navigatie mislukt. Probeer de pagina te verversen en opnieuw.");
                    }
                }
            })
            .catch(errorInfo => {
                console.error("Form validation errors:", errorInfo);
                openNotificationError("Vul alle verplichte velden in!");
            });
    };
    

    
    return (
        <Card className="form-card" style={{ overflowY: "auto", maxHeight }}>
            <Form form={form} layout="vertical">
                <Row>
                    <Col span={24} className='form-info-2'>

                        <Form.Item 
                            name="klas" 
                            label="Klas" 
                            rules={[{ required: true, message: 'Selecteer een klas' }]}
                        >
                            <Select
                                showSearch
                                placeholder="Selecteer een klas"
                                optionFilterProp="children"
                                onChange={handleKlasChange}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {klassen.map(klas => (
                                    <Option key={klas._id} value={klas._id}>{klas.naam}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item 
                            name="aantal" 
                            label="Aantal" 
                            rules={[{ required: true, message: 'Vul het aantal in' }]}
                        >
                            <InputNumber 
                                style={{ width: '100%' }} 
                                min={1} 
                                placeholder="Aantal studenten"
                                onChange={handleAantalChange} 
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item 
                                    name="datum1" 
                                    label="Datum 1" 
                                    rules={[{ required: true, message: 'Selecteer datum 1' }]}
                                >
                                    <DatePicker 
                                        style={{ width: '100%' }}
                                        format="DD/MM/YYYY" 
                                        onChange={(date) => handleDatumChange(1, date ? date.toDate() : null)}  
                                    />
                                  
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name="datum2" label="Datum 2">
                                    <DatePicker 
                                        style={{ width: '100%' }}
                                        format="DD/MM/YYYY" 
                                        onChange={(date) => handleDatumChange(2, date ? date.toDate() : null)}  
                                        disabled={isEdit}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name="datum3" label="Datum 3">
                                    <DatePicker 
                                        style={{ width: '100%' }} 
                                        format="DD/MM/YYYY"
                                        onChange={(date) => handleDatumChange(3, date ? date.toDate() : null)}
                                        disabled={isEdit}  
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                            <Row gutter={16}>
                                <Col span={18}>
                                    <Form.Item name="voorgerecht"   label={
                                    <Space>
                                    Voorgerecht
                                    {allergenenVoorgerecht.length > 0 && (
                                        <Alert
                                        message={allergenenVoorgerecht.join(', ')}
                                        type="warning"
                                        banner
                                        style={{ padding: 1 }}
                                        />
                                    )}
                                    </Space>
                                }
                                >
                                    <Space>
                                    
                                    </Space>

                                        <Select
                                            showSearch
                                            allowClear   
                                            placeholder="Selecteer een voorgerecht"
                                            optionFilterProp="children"
                                            onChange={handleVoorgerechtChange}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            className={allergenenVoorgerecht.length > 0 ? 'warning-select' : ''}
                                            value={selectedVoorgerecht?._id}
                                        >
                                            {voorgerechten.map(voorgerecht => (
                                                <Option key={voorgerecht._id} value={voorgerecht._id}>
                                                    {voorgerecht.naam}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item 
                                        name="aantalVoorgerecht" 
                                        label="Aantal" 
                                        rules={[{ required: !!selectedVoorgerecht, message: 'Vul het aantal in' }]}
                                    >
                                        <InputNumber 
                                            style={{ width: '100%' }} 
                                            min={1} 
                                            placeholder="Aantal"
                                            onChange={handleAantalVoorgerechtChange} 
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                    </Col>

                    <Col span={24}>
                            <Row gutter={16}>
                                <Col span={18}>
                                    <Form.Item name="hoofdgerecht" label={
                                <Space>
                                    Hoofdgerecht
                                    {allergenenHoofdgerecht.length > 0 && (
                                        <Alert
                                            message={
                                                <Space>
                                                    
                                                    {allergenenHoofdgerecht.join(', ')}
                                                </Space>
                                            }
                                            type="warning"
                                            banner
                                            style={{ padding: 1 }}
                                        />
                                    )}
                                </Space>
                            }>
                                        <Select
                                            showSearch
                                            allowClear
                                            placeholder="Selecteer een hoofdgerecht"
                                            optionFilterProp="children"
                                            onChange={handleHoofdgerechtChange}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            className={allergenenHoofdgerecht.length > 0 ? 'warning-select' : ''}
                                            value={selectedHoofdgerecht?._id}
                                        >
                                            {hoofdgerechten.map(hoofdgerecht => (
                                                
                                                <Option key={hoofdgerecht._id} value={hoofdgerecht._id}>
                                                    {hoofdgerecht.naam}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item 
                                        name="aantalHoofdgerecht" 
                                        label="Aantal" 
                                        rules={[{ required: !!selectedHoofdgerecht, message: 'Vul het aantal in' }]}
                                    >
                                        <InputNumber 
                                            style={{ width: '100%' }} 
                                            min={1} 
                                            placeholder="Aantal"
                                            onChange={handleAantalHoofdgerechtChange} 
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                    </Col>

                    <Col span={24}>
                        <Row gutter={16}>
                                <Col span={18}>
                                    <Form.Item name="nagerecht" label={
                                <Space>
                                    <span>Nagerecht</span>
                                    {allergenenNagerecht.length > 0 && (
                                        <Alert
                                            message={
                                                <Space>
                                                    {allergenenNagerecht.join(', ')}
                                                </Space>
                                            }
                                            type="warning"
                                            banner
                                            style={{ padding: 1 }}
                                        />
                                    )}
                                </Space>
                            }>
                                        <Select
                                            showSearch
                                            allowClear
                                            placeholder="Selecteer een nagerecht"
                                            optionFilterProp="children"
                                            onChange={handleNagerechtChange}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            className={allergenenNagerecht.length > 0 ? 'warning-select' : ''}
                                            value={selectedNagerecht?._id}
                                        >
                                            {nagerechten.map(dessert => (
                                                <Option key={dessert._id} value={dessert._id}>{dessert.naam}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item 
                                        name="aantalNagerecht" 
                                        label="Aantal" 
                                        rules={[{ required: !!selectedNagerecht, message: 'Vul het aantal in' }]}
                                    >
                                        <InputNumber 
                                            style={{ width: '100%' }} 
                                            min={1} 
                                            placeholder="Aantal"
                                            onChange={handleAantalNagerechtChange} 
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                    </Col>

                    <Col span={24}>
                        <Form.Item name="opmerking" label="Opmerkingen">
                            <TextArea
                                placeholder="Geef hier aanvullende informatie of andere opmerkingen."
                                autoSize={{ minRows: 3, maxRows: 6 }}
                                onChange={handleOpmerkingChange}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item>
                    <Button type="primary" size="large" onClick={validateFormEnNavigeer}>
                        Overzicht menu
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default LeerkrachtScreen;